   const reviews = [
  {
    name: "Rahul S.",
    title: "Perfect fit and fabric",
    text: "The quality feels premium and the fit looks even better in person.",
  },
  {
    name: "Ananya M.",
    title: "Worth the price",
    text: "Good stitching, soft fabric, and the design stands out nicely.",
  },
  {
    name: "Karan P.",
    title: "Looks stylish",
    text: "Got compliments instantly. Really clean design.",
  },
  {
    name: "Sana K.",
    title: "Will order again",
    text: "Comfortable and premium finish. Loved it.",
  },

   {
    name: "Mithun D.",
    title: "Superb quality",
    text: "The fabric is soft and the print quality is excellent. Highly recommend!",
  },

    {
    name: "Priya R.",
    title: "Exceeded expectations",
    text: "The shirt looks even better in person. The colors are vibrant and the fit is perfect.",
  },
];

export default reviews;